import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

type MultipleDeliveryTrigger = "checkbox" | "button";
type MultipleDeliveryAction = "select" | "remove";
type MultipleDeliverySection = "card" | "footer";

const selectForMultipleDeliveryDataPush = (
  vehicle: Vehicle,
  trigger: MultipleDeliveryTrigger,
  action: MultipleDeliveryAction,
  section: MultipleDeliverySection
) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: trigger,
        label: "request-delivery",
        action,
        section,
      },
      ...vehicleDataPush,
    });
  }
};

export default selectForMultipleDeliveryDataPush;
